import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { FirmwareService, ModuleName } from "../services/firmware/firmware.service";

@Component({
  selector: 'dcc-create-module',
  templateUrl: './create-module.component.html',
  styleUrls: ['./create-module.component.scss'],
})
export class CreateModuleComponent implements OnInit {
  @Output() refreshPage: EventEmitter<any> = new EventEmitter();
  @Output() closePage: EventEmitter<any> = new EventEmitter();

  icons: string[] = ['lx-main-devices', 'lx-device-health', 'lx-subtract', 'lx-main-rair', 'lx-driver', 'lx-coaching',
    'lx-group', 'lx-user', 'lx-localshipping', 'lx-lftnav-vehicle', 'lx-vehicle-reverse', 'lx-collision',
    'lx-pin', 'lx-compass', 'lx-risk-map', 'lx-main-fleet-tracking', 'lx-lftnav-library', 'lx-tagged', 'lx-events',
    'lx-volume-medium', 'lx-circle-check', 'lx-circle-plus', 'lx-circle-minus', 'lx-ribbon'];
  pageTitle: string = "Create Module";
  isUpdate: boolean = false;
  isActive: boolean[] = new Array(24).fill(false);
  module: ModuleName;
  moduleToUpdate: ModuleName;
  moduleName: string;
  moduleDescription: string;
  moduleIcon: string;

  constructor(
    private toastr: ToastrService,
    private firmwareService: FirmwareService,
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    if (this.moduleToUpdate !== undefined) {
      this.isUpdate = true;
      this.pageTitle = 'Edit Module';
      this.loadData();
    }
  }

  async create() {
    if (!this.isValidModule())
      return;

    this.module = {
      name: this.moduleName.trim(),
      description: this.moduleDescription,
      icon: this.moduleIcon
    };

    try {
      await this.firmwareService.postModuleName(this.module);
      this.toastr.success('Created Module: ' + this.module.name);
      this.refreshPage.emit();
      this.close();
    } catch (e) {
      this.toastr.error(`Failed to submit the new request, please try again.`);
      return;
    }
  }

  private isValidModule(): boolean {
    var operationType = this.isUpdate ? 'update' : 'create';
    if (!this.moduleName) {
      this.toastr.error(`Cannot ${operationType === 'create' ? 'Create' : 'Update'} Module Without Module name`);
      return false;
    }
    if (!this.moduleDescription) {
      this.toastr.error(`Cannot ${operationType === 'create' ? 'Create' : 'Update'} Module Without Module Description`);
      return false;
    }
    if (!this.moduleIcon) {
      this.toastr.error(`Cannot ${operationType === 'create' ? 'Create' : 'Update'} Module Without Module Icon`);
      return false;
    }
    return true;
  }

  private loadData(): void {
    this.moduleName = this.moduleToUpdate.name;
    this.moduleDescription = this.moduleToUpdate.description;
    this.moduleIcon = this.moduleToUpdate.icon;
  }

  onSelectIcon(event: any, index: number) {
    this.isActive.fill(false);
    this.moduleIcon = event.target.className.split(' ')[1];
    this.isActive[index] = !this.isActive[index];
  }

  async update() {
    if (!this.isValidModule())
      return;
    this.module = {
      name: this.moduleName,
      description: this.moduleDescription,
      icon: this.moduleIcon
    };
    try {
      await this.firmwareService.postModuleName(this.module);
      this.toastr.success('Updated Module: ' + this.module.name);
      this.refreshPage.emit();
      this.closePage.emit();
      this.close();
    } catch (e) {
      this.toastr.error('Failed to Update the Module : ' + e.error.message);
    }
  }

  close() {
    if (this.isUpdate) {
      this.closePage.emit();
    }
    this.activeModal.close(false);
  }
}
